import { Fragment } from 'react';

export const setPartnerBannerLogo = (partnerLogo: { name: string; img: string }) => (
  <Fragment>
    &nbsp;<span>with</span>
    <img
      src={partnerLogo.img}
      className={`partner-logo ${partnerLogo.name.toLowerCase()}`}
      alt={`Avalara + ${partnerLogo.name}`}
    />
  </Fragment>
);
